import { useState, useEffect } from 'react';

/**
 * Хук для проверки сезонных событий
 * @param {Object} options - Настройки события
 * @param {number} options.month - Месяц (0–11)
 * @param {number} [options.startDay] - День начала (опционально)
 * @param {number} [options.endDay] - День окончания (опционально)
 * @returns {boolean} - Флаг, активно ли событие сейчас
 */
function useSeasonalEvent(options) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentDay = today.getDate();

    if (options.month !== undefined && currentMonth !== options.month) {
      setIsActive(false);
      return;
    }

    if (
      options.startDay !== undefined &&
      options.endDay !== undefined &&
      (currentDay < options.startDay || currentDay > options.endDay)
    ) {
      setIsActive(false);
      return;
    }

    setIsActive(true);
  }, [options]);

  return isActive;
}

export default useSeasonalEvent;
